:host {
  display: block;
}

::slotted(picture[slot=image]),
::slotted(img[slot=image]) {
  @apply flex w-full h-auto rounded-[5px] overflow-hidden;
}

::slotted([slot=links-left]:not(:last-of-type)) {
  @apply pb-[10px];
}

::slotted([slot=links-left]:nth-of-type(odd):not(:last-of-type)) {
  @apply border-0 border-b-[2px] border-grey-lighter border-solid tablet-portrait:border-b-0;
}

::slotted([slot=links-right]:first-of-type) {
  @apply mt-[30px] tablet-portrait:mt-0;
}
